import styled from 'styled-components';
import { spacing, colors, H1, body2 } from 'ui/theme';
import { Card } from 'ui/card';
import { Skeleton } from 'ui/skeleton';
import { pxToRem } from 'utils/convert';
import { abbrNumber } from 'utils/chart';

const Container = styled.ul`
  display: grid;
  gap: ${spacing.base};
  grid-template-columns: repeat(auto-fit, minmax(${pxToRem(150)}, 1fr));
  list-style: none;
  margin-bottom: ${spacing.half};
  margin-top: ${spacing.half};
  padding-left: 0;
  place-items: stretch;
`;

const Item = styled.div`
  border: ${spacing.single} solid ${colors.black};
  display: grid;
  padding: ${spacing.base} ${spacing.half};
  place-items: center;
  &:last-of-type {
    ${body2}
    border-top: unset;
  }
`;

const SkeletonContainer = styled.div`
  border: ${spacing.single} solid ${colors.black};
`;

type Props = {
  data?: { data: Array<{ name?: number }>; headers: Array<{ id: string; name: string }> };
};

export const InternalMetricsSummaryGrid = ({ data }: Props) => {
  return !data ? null : (
    <Container>
      {data.data.map(({ name }, i) => {
        const displayedData = abbrNumber(name);
        return (
          <Card key={i}>
            {displayedData ? (
              <Item>{<H1>{displayedData}</H1>}</Item>
            ) : (
              <SkeletonContainer data-test="data-loading">
                <Skeleton height={90} />
              </SkeletonContainer>
            )}
            <Item>{data.headers[i].name}</Item>
          </Card>
        );
      })}
    </Container>
  );
};
